import { render } from "./CardPreviewSMS.vue?vue&type=template&id=98cb94c8"
import script from "./CardPreviewSMS.vue?vue&type=script&lang=js"
export * from "./CardPreviewSMS.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__